/**
 * SourceIcon/index.js
 * desc: system icon for unconfigured source type
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const SourceIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="source icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.source.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 12 18" xmlns="http://www.w3.org/2000/svg"><path d="M10 4V0H8v4H4V0H2v4C.9 4 0 4.9 0 6v5.5L3.5 15v3h5v-3l3.5-3.5V6c0-1.1-.9-2-2-2z"/></svg>
    </IconButton>
);


export default SourceIcon;
